<template>
  <div
    v-if="!render"
    ref="root"
    class="observer">
    <slot name="fallback" />
  </div>
  <slot v-if="render" />
</template>
<script setup>

const emit = defineEmits(['intersect'])
const props = defineProps({
  rootMargin: {
    type: String,
    default: '100px'
  }
})
const slots = useSlots()
const observer = ref()
const root = ref()
const render = ref(false)

const onIntersect = event => {
  const isIntersecting = event.find(entry => {
    return entry.isIntersecting
  })

  if (isIntersecting && !render.value && slots.default) {
    render.value = true
    if (observer.value) {
      observer.value.unobserve(root.value)
      observer.value.disconnect()
      observer.value = null
    }
  }

  if (isIntersecting) {
    emit('intersect', event)
  }
}

onMounted(() => {
  observer.value = new IntersectionObserver(onIntersect, {
    rootMargin: props.rootMargin
  })

  observer.value.observe(root.value)
})

onUnmounted(() => {
  if (!observer.value) { return }
  observer.value.disconnect()
  observer.value = null
})
</script>
<style scoped>
.observer {

    display: block;
    min-height: 10px;
    min-width: 10px;

}
</style>
